/* @flow */
import React from 'react';
import TabBar from './TabBar';
import { sensorEventTypes, track } from '../../utils/sensors';

type Props = {
  children: React.DOM,
  defaultActiveKey: string,
};
type States = {
  activeKey: string
};
export default class Tab extends React.PureComponent<Props, States> {
  static defaultProps = {
    defaultActiveKey: '1',
  }

  constructor(props: Props) {
    super(props);
    const activeKey = props.defaultActiveKey;
    this.state = {
      activeKey,
    };
  }

  renderTabContent = () => {
    const { activeKey } = this.state;
    const { children } = this.props;
    const content = [];
    React.Children.forEach(children, child => {
      if (!child) return;
      const active = child.key === activeKey;
      content.push(React.cloneElement(child, {
        active,
      }));
    });
    return content;
  }

  _onTabClick = (activeKey: string) => {
    track(sensorEventTypes.SWITCH_TAB, activeKey);
    this.setState({
      activeKey,
    });
  }

  render() {
    const { activeKey } = this.state;
    const { children } = this.props;
    const tabDataSource = [];
    React.Children.forEach(children, child => {
      if (!child) return;
      tabDataSource.push({
        key: child.key,
        label: child.props.tab,
      });
    });

    return (
      <div className="tab">
        <TabBar
          activeKey={activeKey}
          onTabClick={this._onTabClick}
          dataSource={tabDataSource}
        />
        <div className="tab-content">
          {this.renderTabContent()}
        </div>
      </div>
    );
  }
}
